export default __webpack_public_path__ + "static/media/D-wallet-Extension-2024.43919415.zip";